module.exports = __webpack_public_path__ + "static/media/TeresaOliveiraHover.4f70cfd0.png";